import React from "react";
import { SMART_COLORS as COLORS } from '../../../theme/smartStableTheme';
import { Paper, Typography } from "@mui/material";

// comments: English only
export default function KPI({ title, value }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.2,
        border: "1px solid #eadfca",
        borderRadius: 2,
        background: COLORS.card,
        boxShadow: "0 8px 22px rgba(91, 75, 39, 0.06)",
        textAlign: "center",
        display: "grid",
        gap: 0.5,
        justifyItems: "center",
      }}
    >
      <Typography variant="subtitle2" sx={{ color: COLORS.gold, fontWeight: 800 }}>
        {title}
      </Typography>
      <Typography variant="h5" sx={{ color: COLORS.text, fontWeight: 900, lineHeight: 1.2 }}>
        {value}
      </Typography>
    </Paper>
  );
}
